module.exports = __webpack_public_path__ + "static/team_table-159d4568d58550d1ea50bab4df80e236.svg";